if (!customElements.get('personalize-options-modal')) {
  class PersonalizeOptionsModal extends HTMLElement {
    constructor() {
      super();

      this.formWrapper = this.querySelector('.personalize-options-form-label');
      this.content = this.querySelector('.personalize-options-modal-content');
      this.triggerFormButton = this.querySelector('.personalize-product-modal-button');
      this.modal = this.querySelector('x-modal');

      this.contactTabs = this.querySelectorAll('[data-personalize-contact-target]');
      this.contactPanels = this.querySelectorAll('[data-personalize-contact-content]');
      this.chatButton = this.querySelector('[data-open-personalize-chat]');

      if (!this.formWrapper || !this.content || !this.triggerFormButton || !this.modal) {
        return;
      }

      this.init();
    }

    init() {
      this.triggerFormButton.addEventListener('click', () => {
        this.content.setAttribute('hidden', '');
        this.formWrapper.removeAttribute('hidden');
      });

      this.contactTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-personalize-contact-target');

          this.contactTabs.forEach((item) => item.classList.remove('active', 'is-active'));
tab.classList.add('active', 'is-active');

          this.contactPanels.forEach((panel) => {
            if (panel.getAttribute('data-personalize-contact-content') === target) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        });
      });

      if (this.chatButton) {
        this.chatButton.addEventListener('click', () => {
          const inboxElement = document.querySelector('inbox-online-store-chat');

          if (this.modal && typeof this.modal.hide === 'function') {
            this.modal.hide();
          }

          if (inboxElement && inboxElement.shadowRoot) {
            const chatToggleButton = inboxElement.shadowRoot.querySelector('button.chat-toggle');

            if (chatToggleButton) {
              chatToggleButton.click();
            } else {
              console.warn('Przycisk czatu nie znaleziony w shadowRoot');
            }
          } else {
            console.warn('Element inbox-online-store-chat lub jego shadowRoot nie istnieje jeszcze');
          }
        });
      }

      this.modal.addEventListener('dialog:force-close', () => {
        setTimeout(() => {
          this.formWrapper.setAttribute('hidden', '');
          this.content.removeAttribute('hidden');

          this.contactTabs.forEach((item) => item.classList.remove('active'));
          this.contactPanels.forEach((panel) => panel.setAttribute('hidden', ''));
        }, 500);
      });
    }
  }

  customElements.define('personalize-options-modal', PersonalizeOptionsModal);
}